<app-loading-shadow aria-hidden="true" class="loading-card-extra" *ngIf="isLoading; else showCardExtra"></app-loading-shadow>

<ng-template #extraInfoTemplate>
	<ng-content select="[extraInfo]"></ng-content>
</ng-template>

<ng-template #titleContentTemplate>
	<ng-content select="[titleContent]"></ng-content>
</ng-template>

<ng-template #showCardExtra>
	<article class="card-extra " [ngClass]="{'is-active': isAdded}">
		<!-- Image -->
		<div class="card-extra__image">
			<app-svg *ngIf="image===''" aria-hidden="true" 
				[svg]="logoFilename" 
				class="icon"
				[alt]="title + ' icon'">
			</app-svg>
			<div *ngIf="isAdded&&image!==''" class="image" [ngStyle]="{'background-image':'url(' + image + ')'}">
				<app-svg aria-hidden="true" [svg]="'icons.svg#general--check'" class="icon white" [alt]="title + ' icon'">
				</app-svg>
			</div>

			<h3 *ngIf="title" class="title-h3 no-margin-bottom" skeletonLoader [translationKey]="titleKey" [innerHTML]="title"></h3>
			<h3 *ngIf="!title" class="title-h3 no-margin-bottom" skeletonLoader [translationKey]="titleKey">
				<ng-container *ngTemplateOutlet="titleContentTemplate"> </ng-container>
			</h3>
		</div>

		<!-- Body -->
		<div class="card-extra__body">
			<h3 *ngIf="title" class="title-h3 no-margin-bottom" skeletonLoader [translationKey]="titleKey" [innerHTML]="title"></h3>
			<h3 *ngIf="!title" class="title-h3 no-margin-bottom" skeletonLoader [translationKey]="titleKey">
				<ng-container *ngTemplateOutlet="titleContentTemplate"> </ng-container>
			</h3>
			
			<div *ngIf="stars" class="card-extra__rating-stars-wrapper">
				<app-svg class="card-extra__rating-star" [alt]="'Rating star'" svg="sprite.svg#misc--rating-star--full"
				*ngFor="let star-full of INDRA_printStars()" [attr.aria-label]="INDRA_printStars() + ' stars rating'"></app-svg>
			</div>

			<div class="card-extra__body--description" *ngIf="description">
				<span class="no-margin" skeletonLoader [translationKey]="descriptionKey" [innerHTML]="description"></span>
			</div>
			
			<div class="card-extra__body--description" *ngIf="!description">
				<ng-content select="[description]"></ng-content>
			</div>

			<div class="card-extra__body--extra">
				<ng-content select="[message]"></ng-content>
			</div>
		</div>

		<!-- Actions -->
		<div class="card-extra__actions">
			<ng-container *ngIf="!isAdded">
				<span *ngIf="!hasExtraInfo" [tooltip]="toolTipText ? toolTipText : null" class="label" skeletonLoader [translationKey]="infoKey" [innerHTML]="info">
				</span>
				<span *ngIf="hasExtraInfo" [tooltip]="toolTipText ? toolTipText : null" class="label" skeletonLoader [translationKey]="infoKey">
					{{ info }}
					<ng-container *ngTemplateOutlet="extraInfoTemplate"> </ng-container>
				</span>
				<ng-container>
					<div class="added" *ngIf="oldprice !== null && price !== null">
						<label class="regular line-through text-old-value">{{ oldprice }}</label>
						<label *ngIf="showPrice" class="text">{{ price | indracurrency }}</label>
					</div>
				</ng-container>
				<button *ngIf="(externalLink === null) && !disabled" [ngClass]="modifierButton" class="button button--small" 
					[ngClass]="{'no-margin': (oldprice === null && price === null) }"
					(click)="disabled ? false : INDRA_sidebarOpen()"
					[attr.aria-label]="'Open dialog for more details and to add ' + title"
				>
					<span skeletonLoader [translationKey]="labelKey">
						{{ label }}
					</span>
				</button>

				<a *ngIf="(externalLink !== null) && !disabled" 
					[href]="externalLink" target="_blank" class="button button--small button--icon-right" 
					[ngClass]="{'no-margin': (oldprice === null && price === null) }"
					[attr.aria-label]="'Open dialog for more details and to add ' + title"
				>
					<span skeletonLoader [translationKey]="labelKey">
						{{ label }}
					</span>
					<app-svg svg="icons.svg#interface--external_link" [alt]="'External link icon'" aria-hidden=true></app-svg>
				</a>
			</ng-container>
			<ng-container *ngIf="isAdded">
				<a *ngIf="!disabled" href="javascript:;" 
					role="button" 
					[attr.aria-label]="confirmation + ', open dialog.'"  
					class="link link--white"
					(click)="disabled ? false : INDRA_sidebarOpen()">
					<span skeletonLoader [translationKey]="confirmationKey">
						{{ confirmation }}
					</span>
				</a>
				<div class="added">
					<label>{{ price | indracurrency }}</label>
					<app-svg *ngIf="closeButton && !disabled" 
						svg="icons.svg#general--close" 
						class="close-icon" 
						(click)="INDRA_extraChanged()" 
						[alt]="'Remove extra'" 
						aria-label="Remove extra">
					</app-svg>
				</div>

				<div class="added">
					<app-svg svg="sprite.svg#flight--brand-checked" class="close-icon" style="margin-right: 1rem;" aria-hidden=true  [alt]="'Checked icon'">
					</app-svg>
					<a *ngIf="!disabled"  href="javascript:;" role="button" [attr.aria-label]="confirmation + ', open dialog.'"
						class="button button-tonal-tertiary" (click)="disabled ? false : INDRA_sidebarOpen()" >{{ confirmation }}</a>
				</div>
			</ng-container>
		</div>
	</article>
</ng-template>

